import { Badge } from '@/components/ui/badge'
import { dateTime } from '@/lib/format'
import { cn } from '@/lib/utils'

import { useFreshness, type FreshnessState } from './api'

const TONE: Record<FreshnessState, 'positive' | 'warning' | 'negative' | 'slate'> = {
  FRESH: 'positive',
  AGING: 'warning',
  STALE: 'negative',
  NO_DATA: 'slate',
}

const WORD: Record<FreshnessState, string> = {
  FRESH: '',
  AGING: 'Aging · ',
  STALE: 'Stale · ',
  NO_DATA: '',
}

/**
 * "Data as of 28 Sep 2026 23:59" — how old the DPD data behind this screen
 * is. Warns only (BRD: "warn in MVP"); nothing is blocked on it.
 */
export function FreshnessBadge({ className }: { className?: string }) {
  const { data } = useFreshness()
  if (!data) return null

  const title =
    data.state === 'NO_DATA'
      ? 'No DPD data has arrived yet.'
      : `Aging after ${data.agingHours}h, stale after ${data.staleHours}h without newer data.`

  return (
    <Badge tone={TONE[data.state]} className={cn('normal-case tracking-normal', className)} title={title}>
      {data.state === 'NO_DATA'
        ? 'No DPD data yet'
        : `${WORD[data.state]}Data as of ${dateTime(data.asOfAt)}`}
    </Badge>
  )
}
